$(function(){

    var _animIndex={},_animStorage={};
    /*
     * imagesObj={
     *      "1":{
     *          conf:{period_min:50,period_max:100},
     *          arr:[
        *          {path:"/gfx/place/fight/animation/cherry/1/anim.png","conf":{clips:9,height:361,width:567,left:100,top:100}},
        *          {path:"/gfx/place/fight/animation/cherry/2/anim.png","conf":{clips:9,height:361,width:567,left:0,top:0}},
     *          ]
     *      },
     * }
     */
    
    $.fn.animCircleLoop=function(options,imagesObj,timeHandler){
        var th=$(this);
        var settings=th.data("animCircleLoop");
        var animIndex;
        
        function removeAnim(){
            delete _animIndex[animIndex];
            delete _animStorage[animIndex];
            th.data("animCircleLoop",false);
        }
        function prepareNextScene(nextMili){
            timeHandler.setOne(animIndexArr.handler,function(){
                drawScene();
            },nextMili,function(){},function(){
                removeAnim();
            });
        }
        function drawScene(){
            
            if(typeof _animStorage[animIndex]!=="undefined"){
                
                
                var nextMili=_animStorage[animIndex].obj_anim.takePreriod();
                if(nextMili>0){
                    prepareNextScene(nextMili);
                }
                _animStorage[animIndex].obj_anim.draw(ctx);
                
                
            }
            return true;
        }
        var methods={
            start:function(){
                _animStorage[animIndex].obj_anim.start();
            },
            takeAnimIndex:function(){
                return animIndex;
            }
        };
        
        
        
        /*
         * allImages={"1":{img:img,"conf":{clips:9,height:361,width:567}}}
         * 
         * 
         */
        function animObj(allImages){
            this.conf_arr={};
            this.image_arr={};
            var type;
            for(type in allImages){
                this.conf_arr[type]=allImages[type].conf;
                this.image_arr[type]=allImages[type].arr;
            }
            
            this.anim_type=-1;
            this.step=0;
            this.step_max=0;
            this.period=0;
            
        }
        animObj.prototype={
            init:function(){
                this.setNewAnim();
            },
            setNewAnim:function(){
                var type_arr=[],type;
                for(type in this.conf_arr){
                    type_arr.push(type);
                }
                this.anim_type=type_arr[mt_rand(0,type_arr.length-1)];
                this.step=0;
                this.step_max=this.conf_arr[this.anim_type].step_max;
                this.period=mt_rand(this.conf_arr[this.anim_type].period_min,this.conf_arr[this.anim_type].period_max);
            },
            start:function(){
                drawScene();
            },
            takePreriod:function(){
                return this.period;
            },
            draw:function(ctx){
                
                //clip_cur,clip_max
                
                
                var i,cur_conf;
                ctx.clearRect(0, 0, settings.width, settings.height);
                for(i in this.image_arr[this.anim_type]){
                    cur_conf=this.image_arr[this.anim_type][i];
                    drawImageCrop(
                        ctx,
                        cur_conf.img,
                        cur_conf.conf.left,cur_conf.conf.top,
                        cur_conf.conf.width*this.step,0,
                        cur_conf.conf.width,cur_conf.conf.height
                    );
                }
                this.step++;
                if(this.step>=this.step_max){
                    this.setNewAnim();
                }
            },
            stopView:function(ctx){
                this.draw(ctx);
            }
        };
        
        
        if(!settings){
            if(typeof options!="object"){
                return false;
            }
            settings=$.extend( {
                width:1280,//{path:"gfx/place/fight/animation/cherry/1/anim.png",}
                height:780,
            }, options);
            th.attr({width:settings.width,height:settings.height});
            
            function getNewAnimIndex(){
                var i=getNewObjectIndex(_animIndex,{});
                _animIndex[i]={handler:timeHandler.getNewIndex()};
                _animStorage[i]={"obj_anim":{},cur_anim:""};
                
                //
                return i;
            }
            function initAnim(animIndex,imagesReady){
                _animStorage[animIndex].obj_anim=new animObj(copyObj(imagesReady));
                _animStorage[animIndex].obj_anim.init();
            }
            if(typeof timeHandler=="undefined" || typeof timeHandler.getNewIndex=="undefined"){
                return false;//was not init
            }
            animIndex=getNewAnimIndex();
           
            var animIndexArr=_animIndex[animIndex];
           
            settings.animIndex=animIndex;
            var ctx=th[0];
            ctx=ctx.getContext("2d");
            function prepareImages(){
                var i,type,bum,obj;
                var imageAll={},clip_max;
                for(type in imagesObj){
                    clip_max=0;
                    imageAll[type]={
                        conf:$.extend({
                            period_min:50,
                            period_max:100
                        },imagesObj[type].conf),
                        arr:[]
                    };
                    
                    for(i in imagesObj[type].arr){
                        bum=imagesObj[type].arr[i];
                        obj={
                            conf:$.extend({
                                left:0,
                                top:0
                                },
                                copyObj(bum.conf)
                            ),
                            img:new Image()
                        };
                        clip_max=Math.max(clip_max,obj.conf.clips)
                        obj.img.src=bum.path;
                        imageAll[type].arr.push(obj);
                    }
                    imageAll[type].conf.step_max=clip_max;
                    
                }
                return imageAll;
            }
     
            function preparePreloadArr(){
                var arr=[];
                var type,i;
                for(type in imagesObj){
                    for(i in imagesObj[type].arr){
                        arr.push(imagesObj[type].arr[i].path);
                    }
                }
                return arr;
            }
            
            
            
            $("<div/>").one("myload",function(){
                initAnim(animIndex,prepareImages());
                
                _animStorage[animIndex].obj_anim.stopView(ctx);
                
                th.data("animCircleLoop",settings);
                th.trigger("was_loaded");
            }).myLoad(preparePreloadArr());
            
            
            
            
        }
        else{
            var arg =Array.prototype.slice.call(arguments,1);
            animIndex=settings.animIndex;
            if(methods[options]){
                return methods[options].apply(this,arg);
            }
            
        }
        
        return true;
        
    };
});


